import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import TimeInputWithValidation from '../../../../components/ValidationFormElements/TimeInputWithValidation';
import useRegisterValidationFields from '../../../../hooks/useRegisterValidationFields';

const AccidentTime = ({ formProps, accidentInfo }) => {
  const { t } = useTranslation();

  const { errors, clearError, setValue, register } = formProps;
  const [accTime, setAccTime] = useState(accidentInfo && accidentInfo.accidentTime);

  useRegisterValidationFields(['accidentTime'], register);

  const updateAccTime = () => (event) => {
    setAccTime(event.target.value);
    setValue('accidentTime', event.target.value, true);
  };

  return (
    <TimeInputWithValidation
      formProps={{ errors, clearError }}
      handleTimeChange={updateAccTime()}
      value={accTime}
      name="accidentTime"
      label={t('claim.accInfo.time')}
    />
  );
};

AccidentTime.propTypes = {
  formProps: PropTypes.shape({
    setValue: PropTypes.func,
    register: PropTypes.func,
    clearError: PropTypes.func,
    errors: PropTypes.shape({}),
  }),
  accidentInfo: PropTypes.shape({
    accidentTime: PropTypes.string,
  }),
};

AccidentTime.defaultProps = {
  accidentInfo: {},
  formProps: {
    register: () => {},
    setValue: () => {},
    clearError: () => {},
    errors: {},
  },
};

export default AccidentTime;
